export default function viewportSize() {
  function calculateViewportSize() {
    const vh = window.innerHeight;
    const vw = $('body').width();
    $('body').css('--vh', `${vh}px`);
    $('body').css('--vw', `${vw}px`);
  }
  $(window).on('resize', function () {
    calculateViewportSize();
  });
  calculateViewportSize();
}
